import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import genericAvatar from "assets/images/users/32/user-dummy-img.jpg";
import { getUserRoleDisplayName, type User } from '../utils/roleBasedAccess';

const ProfileDropdown = () => {
    const { user, role, permissions } = useSelector((state: any) => state.Login);

    const userData: User = {
        ...(user || {}),
        subRole: (user && user.subRole) || role,
        permissions: permissions,
    };

    const userName = userData.fullName || (userData as any).username || userData.email || "Admin";
    const roleDisplayName = getUserRoleDisplayName(userData);

    return (
        <React.Fragment>
            <Dropdown className="ms-sm-3 header-item topbar-user">
                <Dropdown.Toggle type="button" className="btn bg-transparent border-0 arrow-none" id="page-header-user-dropdown">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={genericAvatar} alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                            <span className="d-none d-xl-block ms-1 fs-sm text-muted user-name-sub-text">{roleDisplayName}</span>
                        </span>
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-end">
                    <Dropdown.Item href={process.env.PUBLIC_URL + "/logout"}>
                        <i className="mdi mdi-logout text-muted fs-lg align-middle me-1"></i>
                        <span className="align-middle" data-key="t-logout">Logout</span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </React.Fragment>
    );
}

export default ProfileDropdown;
